<section class="cmn-innerpage-wrapper">
  <div class="scrollWrapper">
    <div class="head">
      <h1>{{ pageId ? "Update" : "New" }} Info Page</h1>
    </div>
    <ng-container *ngIf="!contentLoading">
      <div class="tagsWrapper">
        <form id="translation" [formGroup]="form">
          <div class="flex-form-wrapper">
            <label>
              <span>Key</span>
              <mat-form-field>
                <mat-label *ngIf="!pageId">Select a Key</mat-label>
                <mat-select formControlName="key">
                  <mat-option *ngFor="let key of pageKeys" [value]="key.key">{{
                    key.value
                    }}</mat-option>
                </mat-select>
                <mat-error *ngIf="form.get('key')?.hasError('required')">Key is required</mat-error>
                <mat-error *ngIf="form.get('key')?.hasError('maxlength')">Key cannot exceed 40 characters</mat-error>
                <mat-error *ngIf="form.get('key')?.hasError('onlySpaces')">Key cannot be empty spaces</mat-error>
                <mat-error *ngIf="form.get('key')?.hasError('onlySpecialChars')">No special characters
                  allowed</mat-error>
              </mat-form-field>
            </label>
            <label>
              <span>Choose Language</span>
              <mat-form-field>
                <mat-label>Language</mat-label>
                <mat-select formControlName="langId" (selectionChange)="onLangSelect($event.value)">
                  <mat-option *ngFor="let lang of languages" [value]="lang.id" [disabled]="isLangUsed(lang.id)">
                    {{ lang.name }}
                  </mat-option>
                </mat-select>
                <!-- <mat-hint
                  *ngIf="addWarning && form.get('langId')?.disabled"
                  class="hint"
                  >Add your edits before selecting a different language.
                </mat-hint> -->
                <mat-hint *ngIf="addWarning && isEditing" class="hint">
                  Add your edits before selecting a different language.
                </mat-hint>

                <mat-error *ngIf="form.get('langId')?.hasError('required')">Language is required</mat-error>
              </mat-form-field>
            </label>
          </div>
        <div class="editor-wrapper" *ngIf="form.get('langId')?.value">
            <label class="full-width-Wrapper">
              <div>Content</div>
              <editor [apiKey]="tinyMceApiKey" [init]="tinyInit" formControlName="content">
              </editor>
            </label>
          </div>
        </form>
        <button class="add-button  unblock-pointer" type="button" (click)="addStaticTable()" [style.visibility]="
            staticTranslations.length !== 4 ? 'visible' : 'hidden'">
          Add
        </button>
      </div>
      <div class="grid-wrapper" *ngIf="staticTranslations.length">
        <div class="pageItem" *ngFor="let static of staticTranslations; let i = index">
          <h3>
            {{`${keyValue.replaceAll('_',' ')} (${getLanguageName(static.langId)})`}}
          </h3>
          <div class="actionWrapper">
            <div class="actionItem" *ngIf="static.langId !== 1" (click)="removeStaticTranslation(i, static.id)">
              <img src="../../../assets/images/icons/icon-delete.svg" alt="Delete" />
            </div>
            <div class="actionItem" (click)="editStaticTranslation(i)">
              <img src="../../../assets/images/icons/icon-edit.svg" alt="Edit" />
            </div>
          </div>
        </div>
      </div>
      <div class="btnWrapper">
        <button class="cmn-cancel-btn" (click)="onCancel()">Cancel</button>
        <button class="cmn-next-btn" (click)="saveSTaticPage()" [disabled]="!staticTranslations.length || isSubmitting">
          Save
        </button>
      </div>
    </ng-container>
    <app-content-loader [visible]="contentLoading"></app-content-loader>
  </div>
</section>
